import './ChannelIcon.scss';
import { useState } from 'react';
import { Avatar } from '@Components/Avatar';
import { HierarchyLevel, HierarchyLevelConst } from '../dtc-commerce-mmm-types';
import { resolveIcon } from '../utils/dtc-commerce-mmm-icon-resolver';

interface ChannelIconProps {
  channel: string;
  platform?: string;
  level: HierarchyLevel;
  size?: number;
}

export const ChannelIcon = ({ channel, platform, level, size = 16 }: ChannelIconProps) => {
  const iconPath = resolveIcon(channel, platform, level);
  const [imgFailed, setImgFailed] = useState(false);

  if (iconPath && !imgFailed) {
    return (
      <img
        src={iconPath}
        alt=''
        width={size}
        height={size}
        className='dtc-channel-icon'
        style={{ width: size, height: size }}
        onError={() => setImgFailed(true)}
      />
    );
  }

  const isChannelLevel = level === HierarchyLevelConst.CHANNEL;
  const displayName =
    isChannelLevel || !platform || platform.toLowerCase() === 'total' ? channel : platform;

  return <Avatar name={displayName} size={size} />;
};
